/* companyWindow.js -- THE COMPANY'S MONTH WINDOW AT ONBOARDING: one owner for Step 1's rule, the opening month, and
 * "is this a one-month start" (2026-11-02, diffs/one-month-start-build.txt; the design is
 * diffs/zero-start-first-month-check.txt, option (b)).
 *
 * THE ONE-MONTH START. A brand-new company has no history before the month of its opening balance sheet, so its
 * historical start IS its last closed month (e.g. both 2026-10, the forecast from 2026-11). The engine already runs
 * that window (measured: the same forecast, cell for cell, as ten months of zero history).
 *
 * WHY EVERY OTHER START MUST STAY A JANUARY. The engine starts the year at the window's first month: net income
 * year-to-date (engines/orchestrator.js) and the payroll tax caps (engines/computePayroll.js) both reset where the
 * window starts. That is right only when nothing happened before it -- true of a company that starts in its close
 * month, wrong for a company with real activity before a mid-year start. So the exception is exactly
 * historical start == last closed month, and nothing wider. */
import { subtractOneMonth } from '../engines/dateUtils';

// A one-month start -- Brian's name for it, on screen: a PRE-LAUNCH company (2026-11-02) -- the historical start is the last
// closed month (the month of the opening balance sheet).
export function isOneMonthStart(historicalStart, closeMonth) {
    return !!historicalStart && historicalStart === closeMonth;
}

// The opening month: the month BEFORE the historical start -- the balance sheet template's opening column (the
// generator's own rule, templateSpecs.buildHistoricalMonths). For a January start it is the prior December, exactly
// what the retired AdminPage priorDecOf returned.
export function openingMonthOf(historicalStart) {
    if (!historicalStart) return null;
    return subtractOneMonth(historicalStart);
}

// Step 1's window rule. Returns the operator message, or null when the three months are acceptable. The order of the
// checks and the text of every refusal a January start can meet are unchanged from AdminPage's handleSaveStep1.
export function step1WindowError({ historicalStart, closeMonth, forecastThrough }) {
    if (!historicalStart || !closeMonth || !forecastThrough) return 'All fields are required.';
    if (!isOneMonthStart(historicalStart, closeMonth)) {
        if (historicalStart.slice(5) !== '01') {
            return 'Historical Start must be a January (e.g. 2021-01). A Pre-Launch company (no earlier history) starts in '
                + 'its Last Closed Month instead: set Historical Start to the same month as the Last Closed Month.';
        }
        if (closeMonth <= historicalStart) return 'Last Closed Month must be after Historical Start.';
    }
    if (forecastThrough <= closeMonth) return 'Forecast Through must be after Last Closed Month.';
    if (!/-12$/.test(forecastThrough)) {
        return 'Forecast Through must be a December (fiscal year-end). The model\u2019s quarterly and annual rollups are '
            + 'calendar-based, so the forecast horizon must end in December.';
    }
    return null;
}
